import Swiper from 'swiper';

const swiper = new Swiper('.collection-nav__swiper', {
    spaceBetween: 10,
    slidesPerView: 'auto',
    breakpoints: {
        480: {
            spaceBetween: 21,
        },
    },
    centerInsufficientSlides: true,
    threshold: 12,
});

const subswiper = new Swiper('.collection-nav__sub__swiper', {
    spaceBetween: 21,
    slidesPerView: 'auto',
    threshold: 12,
});

document.addEventListener('DOMContentLoaded', () => {
    const sliderContainer = document.querySelector('.collection-nav__sub__swiper');
    const slides = Array.from(sliderContainer.querySelectorAll('.swiper-slide .collection-nav__sublink'));
    const isActive = (slide) => slide.classList.contains('active');
    const activeIndex = slides.findIndex(isActive);

    subswiper.slideTo(activeIndex);
});
